<div class="member-container">
  <div class="member-table">
    <table>
      <thead>
        <tr>
          <th>{{ 'auth.teamMember.name' | translate }}</th>
          <th>{{ 'auth.teamMember.email' | translate }}</th>
          <th>{{ 'auth.teamMember.role' | translate }}</th>
          <!-- <th>Projects</th> -->
          <th>{{ 'auth.teamMember.status' | translate }}</th>
          <th *ngIf="!isPreview"></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let member of members">
          <td>{{ member.name }}</td>
          <td>{{ member.email }}</td>
          <td *ngIf="isPreview">{{ member.role }}</td>
          <td *ngIf="!isPreview">
            <ops-select
              [options]="roleOptions"
              mandatory="true"
              [defaultSelected]="[member.role]"
              [formName]="member.role"
              label=""
              (changed)="onRoleChange($event, member)"
            ></ops-select>
          </td>
          <td [class]="getVerifiedClass(member.isVerified)">
            <div class="member-status">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
              >
                <circle cx="6" cy="6" r="6" fill="#7ED321" />
              </svg>
              <span>{{
                member.isVerified
                  ? ('auth.teamMember.active' | translate)
                  : ('auth.teamMember.invitationPending' | translate)
              }}</span>
            </div>
          </td>
          <!-- <td [class]="getStatusClass(member.status)">
            <div class="member-status">
              <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                <circle cx="6" cy="6" r="6" fill="#7ED321" />
              </svg>
              <span>{{ member.status }}</span>
            </div>
          </td> -->
          <td (click)="deleteTeamMember(member)" *ngIf="!isPreview">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="17"
              height="17"
              viewBox="0 0 17 17"
              fill="none"
            >
              <path
                d="M14.3333 4.83333L13.7367 12.589C13.6032 14.3256 12.155 15.6667 10.4132 15.6667H6.58677C4.84498 15.6667 3.39684 14.3256 3.26326 12.589L2.66667 4.83333M16 3.16667C14 3.16667 11.2614 3.16667 8.5 3.16667C5.73862 3.16667 3 3.16667 1 3.16667M6.83333 2.83301V2.66667C6.83333 1.74619 7.57953 1 8.5 1C9.42047 1 10.1667 1.74619 10.1667 2.66667V2.83301M6.83333 6.5V11.5M10.1667 6.5V11.5"
                stroke="inherit"
                stroke-linecap="round"
              />
            </svg>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="add-new-member" *ngIf="userIsAdmin">
    <ops-invite-member
      [isPreview]="isPreview"
      (invitedMember)="invitedMember($event)"
    />
  </div>
</div>
